export default "__VITE_ASSET__mChzO29B__"